import { HTTPClient } from '@rjgf/http-client'
import { SwaggerApi } from './swagger'
import pinia from '@/store'
import config from '@/config'
import { useUserStore } from '@/store/user'
import router from '@/router'

const client = new HTTPClient(config.apiURL)
const userStore = useUserStore(pinia)

client.on('error', (err) => {
  // eslint-disable-next-line no-console
  console.error(err.message)
})

client.on('unauthorize', () => {
  userStore.logout()
  if (!location.href.includes('/login')) {
    router.push('/login')
  }
})

const api = client as unknown as SwaggerApi

export { api }
